import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'

export default {
	namespaced: true,
	state: {
		courseDates: null,
		tokenValue: null,
	},
	actions: {
		async loadCourseDates({ state, commit, rootState }, { courseType = 'sushi', accumulatorGroup = null } = {}) {
			const result = await service.loadCourseDates({ courseType, brand: config.BRAND, accumulatorGroup })
			commit('setCourseDates', { item: result })
		},
		async courseRegistration({ commit, dispatch }, { courseId, firstName, lastName, company, participants, street, streetNumber, city, postcode, email, phoneNumber, participantNames, notes, checkTerms, accumulatorGroup = null } = {}) {
			const result = await service.courseRegistration({ courseId, firstName, lastName, company, participants, street, streetNumber, city, postcode, email, phoneNumber, participantNames, notes, checkTerms, brand: config.BRAND, accumulatorGroup })
			commit('setTokenValue', { item: result.tokenValue })

			dispatch('redirect', {
				name: 'checkout-token',
				params: {
					basketToken: result.tokenValue
				}
			}, {root: true})
		}
	},
	getters: {
		courseDates (state) {
			return state.courseDates || []
		},
	},
	mutations: {
		setCourseDates: generateSetChild("courseDates"),
		setTokenValue: generateSetChild("tokenValue"),
	}
}